// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>9</span>&nbsp;&nbsp;My eyes are upon the faithful in the land,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;that they may dwell with me.<br> </p> </div></div>";
// Exports
module.exports = code;